import { render, staticRenderFns } from "./IconEorder.vue?vue&type=template&id=67072c60&"
import script from "./IconEorder.vue?vue&type=script&lang=js&"
export * from "./IconEorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports